export const API_RESPONSE_FAILED = "API_RESPONSE_FAILED";
export const API_DISPLAY_RESPONSE_MESSAGE = "API_DISPLAY_RESPONSE_MESSAGE";
export const API_CLEAR_RESPONSE_MESSAGE = "API_CLEAR_RESPONSE_MESSAGE";
export const MESSAGE_TYPE = {
  ERROR: "error",
  SUCCESS: "success",
};
